"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicAdminTEtherStorageFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "tEther",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b5060918061001e6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c806394635c4614602d575b600080fd5b600054603f906001600160a01b031681565b6040516001600160a01b03909116815260200160405180910390f3fea2646970667358221220f7094360b8090614b9cbfdbe30ff7fec18f41378609be82270ea614ba51dbe9564736f6c63430008030033";
class TectonicAdminTEtherStorageFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicAdminTEtherStorageFactory = TectonicAdminTEtherStorageFactory;
TectonicAdminTEtherStorageFactory.bytecode = _bytecode;
TectonicAdminTEtherStorageFactory.abi = _abi;
//# sourceMappingURL=TectonicAdminTEtherStorageFactory.js.map